var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"dcw-close-button",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('close-button-clicked')}}},[_c('DcwSimpleIcon',{attrs:{"size":_vm.size,"icon":_vm.CrossMark}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }